// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b4f0e5f7","885":"d932cba4"}[chunkId] + ".chunk.js";
};